import React, { PureComponent } from 'react';

import { ModalWithoutPortal } from 'components/modal/ModalWithoutPortal';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class EmbedMediaModal extends PureComponent {
  static propTypes = {
    setMediaUrl: PropTypes.func,
    toggleModal: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.confirmModal = this.confirmModal.bind(this);
  }

  confirmModal = () => {
    const { closeModal } = this._modal.getContext().actions;
    const { setMediaUrl, toggleModal } = this.props;

    setMediaUrl();
    closeModal();
    toggleModal();
  };

  closeModal = () => {
    const { toggleModal } = this.props;
    const { closeModal } = this._modal.getContext().actions;

    closeModal();
    toggleModal();
  };

  render() {
    return (
      <ModalWithoutPortal
        onClose={this.closeModal}
        ref={(node) => (this._modal = node)}
        title="embed_modal.title"
      >
        <ModalWithoutPortal.Body>
          <div>
            <p>
              <I18n label="embed_modal.description" />
            </p>
            <p>
              <I18n label="general.are_u_sure" />
            </p>
          </div>
        </ModalWithoutPortal.Body>

        <ModalWithoutPortal.Footer>
          <button
            className="hot-button hot-button--primary hot-button--lg"
            onClick={this.confirmModal}
          >
            <I18n label="general.ok" />
          </button>
          <button
            className="hot-button hot-button--secondary hot-button--lg"
            onClick={this.closeModal}
          >
            <I18n label="general.cancel" />
          </button>
        </ModalWithoutPortal.Footer>
      </ModalWithoutPortal>
    );
  }
}
